import axios from 'axios';
import {UserInfo} from "../types/interfaces";

export const getToken = () => {
  const currentUser: UserInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  return currentUser.token || "";
}

export const getUsername = () => {
  const currentUser: UserInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
  return currentUser.email || "";
}

const selfcareBaseURL: string = process.env.REACT_APP_API_SELFCARE_URL as string;
const btcAppsBaseUrl: string = process.env.REACT_APP_API_BTCAPPS_URL as string;

export const searchSubscriberKyc = async (msisdn?: string, documentNumber?: string) => {
  const email = getUsername();

  const params: Record<string, string> = {};
  if (msisdn) params.msisdn = msisdn;
  if (documentNumber) params.documentNumber = documentNumber;

  const client = axios.create({
    baseURL: selfcareBaseURL,
    headers: {
      'Content-Type': 'application/json',
      'userId': email,
    },
  });

  const response = await client.get<{ success: boolean; message: string; data: any }>('/subscriber/kyc', { params });

  if (!response.data.success) {
    throw new Error(response.data.message || 'Search failed');
  }

  return response.data.data;
};


export const registerSubscriber = async (subscriberData: any) => {

  //getting the log on user token and username
  const token :string  = getToken();
  const username : string = getUsername();

  const internalConfigs = axios.create({
    baseURL: btcAppsBaseUrl,
    headers: {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'userId': username
    }
  });

  try {
    const response = await internalConfigs.post('/api/register-subscriber', subscriberData);
    return response.data;
  } catch (error) {
    console.error('Error registering subscriber:', error);
    throw error;
  }
};


/**
 * Interface for subscriber data
 * 
 * Defines the structure and required fields for subscriber registration
 * and updates.
 */
export interface SubscriberData {
  firstName: string;
  lastName: string;
  company?: string;
  msisdn: string;
  alternativePhone?: string;
  plotNumber: string;
  street: string;
  cityTownVillage: string;
  city: string;
  billAddress4?: string;
  zipCode?: string;
  nextOfKin: string;
  nextOfKinPhone: string;
  emailAddress: string;
  gender: 'MALE' | 'FEMALE';
  dateOfBirth: string; // Format: YYYY-MM-DD
  nationality: string;
  residencePermitNo?: string;
  residencePermitDateOfExpiry?: string;
  residencePermitDateOfIssue?: string;
  workPermitNo?: string;
  workPermitDateOfExpiry?: string;
  workPermitDateOfIssue?: string;
  idType: 'NATIONAL_ID' | 'PASSPORT';
  idNumber: string;
  idIssueDate: string; // Format: YYYY-MM-DD
  idExpiryDate: string; // Format: YYYY-MM-DD
}
